import React, { useState } from "react";
import { getAPI, postAPI } from "../../../helpers/httpHelper";
import { cognitoUserToken } from "../../../helpers/userHelper";
import { URL_SUPPORT, API_ADMIN_REQUISITOS_SISTEMA, ROW_COUNT, API_ADMIN_REQUISITOS } from "../../../helpers/variableHelper";
import { usePromiseEffect } from "../../../helpers/promiseEffect";
import AdminLista from "../AdminLista";
import { IRequisitos } from "../../../entities/IRequisitos";
import { IRequisitoSistema } from "../../../entities/IRequisitoSistema";
import { cParamsActiveOrderTitle, cParamsPageSize } from "../../../helpers/paramsHelper";
interface IRequisitoSistemaProps {
  cbRequisitos?: Array<IRequisitos>;
  items?: Array<any>;
}
const RequisitoSistema = ({ cbRequisitos, items }: IRequisitoSistemaProps) => {
  const userInfo = cognitoUserToken();
  const [token, setToken] = useState("");
  const [listItems, setListItems] = useState<Array<any>>([]);
  const [comboReq, setComboReq] = useState<Array<IRequisitos>>(cbRequisitos || []);
  const [isLoading, setIsLoading] = useState(false);
  const [pages, setPages] = useState(0);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(ROW_COUNT);

  usePromiseEffect(async () => {
    setIsLoading(true);
    let token = await userInfo;
    setToken(token);
    setToken(token);
    let params = cParamsPageSize(pageSize);
    let result =
      items !== undefined
        ? { data: items, pages: 10 }
        : (await getAPI(`${URL_SUPPORT}${API_ADMIN_REQUISITOS_SISTEMA}/getall?PAGINA=1&PAGINADO=10`, { Authorization: `Bearer ${token}` }, params))
            .result;
    let list = result.data;
    setListItems(list);
    let pages = result.pages;
    setPages(pages);
    const combo = (await getAPI(`${URL_SUPPORT}${API_ADMIN_REQUISITOS}/getall`, { Authorization: `Bearer ${token}` }, cParamsActiveOrderTitle)).result
      .data;
    setComboReq(combo);
    setIsLoading(false);
  }, [token]);

  const paging = (page: any) => {
    setPage(page);
    filter({ PAGINA: page }, true);
  };
  const filter = (filter: Partial<IRequisitoSistema>, havePage: boolean = false, size = pageSize) => {
    if (!filter) {
      filter = {};
      filter.PAGINA = 1;
    }
    filter.TIPO_REQUISITOS = filter.ID_TIPO_REQUISITOS?.toString() || "";
    filter.PAGINADO = size;
    if (filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    if (!havePage && filter.PAGINA === undefined) {
      filter.PAGINA = page ?? 1;
    }
    setPage(filter.PAGINA);
    if (filter.ORDENADOPOR === undefined) {
      filter.ORDENADOPOR = "ID";
      filter.ORIENTACION = "DESC";
    }
    getAPI(`${URL_SUPPORT}${API_ADMIN_REQUISITOS_SISTEMA}/getall`, { Authorization: `Bearer ${token}` }, filter)
      .then((result) => {
        setIsLoading(false);
        setListItems(result.result.data);
        let pages = result.result.pages;
        setPages(pages);
      })
      .catch((error) => {});
  };
  const edit = (value: IRequisitoSistema, filters: any) => {
    delete value.FECHA_CREACION;
    delete value.TRANSACTION_ID;
    if (value.ID == "") {
      delete value.ID;
    }
    value.ID_TIPO_REQUISITOS = value.ID_TIPO_REQUISITOS || 1;
    postAPI(`${URL_SUPPORT}${API_ADMIN_REQUISITOS_SISTEMA}`, value, {
      Authorization: `Bearer ${token}`,
    })
      .then((result) => {
        let data = result.result.data;
        console.log(data);
        filter(filters, value?.ID != undefined);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <button
        data-testid="btnedit"
        hidden={true}
        onClick={() => {
          edit(
            {
              ACTIVO: true,
              ORDENADOPOR: "",
              ORIENTACION: "",
              PAGINA: 1,
              PAGINADO: 10,
              TITULO: "",
              FECHA_MODIFICACION: new Date(),
              ID_REQUISITOS: "",
              ID_TIPO_REQUISITOS: 1,
              TIPO_REQUISITOS: "",
            },
            {}
          );
          paging(1);
        }}></button>
      <AdminLista
        items={[
          {
            type: "ID_TIPO_REQUISITOS",
            value: comboReq.map((tci) => {
              return { text: tci.TITULO, value: tci.ID };
            }),
          },
        ]}
        reload={filter}
        callback={edit}
        data={listItems}
        tipo={"RequisitoSistema"}
        filter={filter}
        pagination={{ pages: pages, page: page, paging: paging }}
        title="Ámbitos de Gestión"
        callbackUpdatePageSize={(pageSize: number, filters: Object) => {
          setPageSize(pageSize);
          filter(filters, false, pageSize);
        }}
        isLoading={isLoading}
      />
    </>
  );
};

export default RequisitoSistema;
